import { Text } from '../../Ant';
import { ChevronDown } from '../../icons';
import { TransactionTypeCategoryHeaderButton } from '../../../assets/styles/components/dashboard.styled';

interface ITransactionTypeCategoryHeaderProps {
  name: string;
  count: number;
  expanded: boolean;
  contentId: string;
  onToggle: () => void;
}

const TransactionTypeCategoryHeader = ({
  name,
  count,
  expanded,
  contentId,
  onToggle,
}: ITransactionTypeCategoryHeaderProps) => (
  <TransactionTypeCategoryHeaderButton
    type="button"
    aria-expanded={expanded}
    aria-controls={expanded ? contentId : undefined}
    onClick={onToggle}
    data-testid="category-header"
  >
    <span className="d-flex items-center gap-10 min-w-0">
      <ChevronDown className="category-header-chevron" />
      <Text
        $fontsize="13px"
        $lineheight="20px"
        $color="primary"
        $weight={600}
        className="lineclamp-1"
        data-testid="category-header-name"
      >
        {name}
      </Text>
    </span>
    <Text
      $fontsize="13px"
      $lineheight="20px"
      $color="primary"
      $weight={600}
      $width="auto"
      className="flex-shrink-0"
      data-testid="category-header-count"
    >
      {count}
    </Text>
  </TransactionTypeCategoryHeaderButton>
);

export default TransactionTypeCategoryHeader;
